<template>
  <div class="layout-sidebar" style="z-index: 999" @click="onMenuClick">
    <div style="height: 4rem" class="p-d-flex p-jc-center p-ai-center">
      <router-link to="/workspace" class="logo" style="padding: 0">
        <img
          id="app-logo"
          src="/assets/layout/images/logo-dark.svg"
          alt="Usee"
          style="height: 36px"
        />
      </router-link>
    </div>

    <div class="layout-menu-container">
      <AppSubmenu
        :items="model"
        :layoutMode="layoutMode"
        :parentMenuItemActive="true"
        :menuActive="active"
        :mobileMenuActive="mobileMenuActive"
        :root="true"
        @menuitem-click="onMenuItemClick"
        @root-menuitem-click="onRootMenuItemClick"
      />
    </div>
    <a
      class="p-d-flex p-jc-center p-pb-4"
      target="_blank"
      href="mailto:info@usee.ai"
    >
      <svg
        width="150"
        height="192"
        viewBox="0 0 150 192"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          opacity="0.100655"
          y="41.271"
          width="150"
          height="150.729"
          rx="21.5327"
          fill="#2E60AD"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.3215 105.958V84.7979C22.3215 81.0754 29.8283 78.0562 39.0837 78.0562H76.9879C86.2466 78.0562 93.7501 81.0754 93.7501 84.7979V106.766L22.3215 105.958Z"
          fill="#DFE0EB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M75.3576 2.96226C70.8776 0.587859 64.0583 0.266852 62.9521 0.116851C49.6974 -1.67987 41.7199 17.7489 41.2514 23.6374C40.386 34.4886 34.6956 36.1429 26.6888 42.9372C10.6297 56.5652 15.3375 72.3989 24.1186 78.2808C29.3892 81.8125 38.6746 78.2808 38.6746 78.2808C38.8048 78.3727 64.0713 64.0324 76.5256 57.1134C95.1973 54.435 86.774 9.01151 75.3576 2.96226Z"
          fill="#233862"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M55.9316 51.2949C52.0154 49.5797 49.052 43.2051 49.1077 43.2018C50.889 43.1208 53.511 40.621 55.0173 30.5046L55.3569 30.7453L67.8569 36.276C67.8569 36.276 66.9336 40.3258 66.3343 44.181C65.8334 47.4202 65.5616 50.5232 66.259 50.9804C66.3147 51.0161 60.0901 53.1172 55.9316 51.2949Z"
          fill="#FFB27D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M67.8572 35.9858C67.8572 35.9858 66.9517 40.0723 66.3641 43.9626C59.1846 42.6473 56.3654 35.3576 55.3572 31.4019L67.8572 35.9858Z"
          fill="#ED975D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M70.4676 39.4722C70.4676 39.4722 52.9396 37.1417 54.5716 26.3682C56.2037 15.5947 55.0422 8.03699 66.3019 9.06552C77.5617 10.0973 79.1082 14.5304 79.4471 18.2572C79.786 21.984 75.0676 39.7977 70.4676 39.4722Z"
          fill="#FFB27D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M78.5714 13.4315C78.5714 13.4315 67.6575 23.2743 60.2354 24.0683C52.8101 24.8623 50 22.3664 50 22.3664C50 22.3664 54.3752 18.564 57.0092 12.4265C57.7838 10.6174 59.4257 9.37782 61.314 9.20696C66.6141 8.72789 76.6607 8.51013 78.5714 13.4315Z"
          fill="#233862"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M71.4285 11.9699C71.4285 11.9699 75.1246 15.6069 76.2918 18.3041C77.4136 20.9091 77.7508 27.1344 76.856 29.6075C76.856 29.6075 82.6207 18.2118 79.3557 12.6756C75.8963 6.803 71.4285 11.9699 71.4285 11.9699Z"
          fill="#233862"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M77.2749 107.805C76.3492 108.599 73.7542 109.074 70.3408 109.297C59.6003 110.008 40.7241 108.247 40.0064 106.273C37.5283 99.444 39.2789 97.3215 37.2133 86.8642C36.9957 85.7529 36.7294 84.5479 36.4176 83.2363C34.693 76.0548 33.0171 73.6125 39.1295 62.073C44.6735 51.6222 50.0112 42.7663 50.5309 43.0732C65.1557 51.7084 66.23 45.3999 66.23 45.3999C66.23 45.3999 81.5035 59.9505 81.2469 76.9432C80.724 111.778 81.104 104.497 77.2749 107.805Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M41.0559 106.284C38.5542 99.3487 39.5856 96.2813 37.5002 85.6617L43.2112 71.7756C43.2112 71.7756 42.3489 88.1824 47.1819 92.4965C52.0149 96.8106 66.9794 100.826 69.3304 104.432C70.4648 106.164 71.2124 107.896 71.4288 109.29C60.5857 110.012 41.7806 108.289 41.0559 106.284Z"
          fill="#EBF3FF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M58.0359 102.294C58.0359 102.294 68.626 99.6948 70.3337 100.729C72.0414 101.768 76.2164 105.541 76.7423 106.855C77.265 108.169 72.9374 105.856 71.5284 105.441C70.6194 105.173 68.217 106.089 67.032 106.526C62.0324 108.366 58.9709 107.421 58.9709 107.421L58.0359 102.294Z"
          fill="#FFB27D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M32.04 50.2334C25.1491 59.8394 11.4834 100.774 19.3168 106.237C28.1378 112.384 59.4584 107.844 59.4584 107.844C59.4584 107.844 60.5009 102.974 59.0517 100.616C57.5993 98.2602 34.0346 94.4558 32.9469 93.3684C31.8592 92.281 46.5416 72.1623 46.5416 68.9001C46.5416 65.6378 50.5305 43.0654 50.5305 43.0654C50.5305 43.0654 36.933 43.4088 32.04 50.2334Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M70.5356 104.075C70.5356 104.075 72.9252 107.036 73.7089 107.389C74.4926 107.741 74.9999 107.654 74.9999 107.654L73.3905 104.87L70.5356 104.075Z"
          fill="#FFB27D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M69.6428 101.383L76.7857 104.553C76.7857 104.553 76.4801 105.006 75.603 104.97C74.7223 104.934 72.5043 104.192 72.5043 104.192L69.6428 101.383Z"
          fill="#FFB27D"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M74.1072 111.252H124.898L140.179 72.6729H89.465L74.1072 111.252Z"
          fill="#DFE0EB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M125 109.458H58.0359V111.252H124.407L125 109.458Z"
          fill="#DFE0EB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M111.502 91.9612C111.911 90.7236 111.089 89.7197 109.666 89.7197C108.245 89.7197 106.763 90.7236 106.354 91.9612C105.948 93.1988 106.77 94.2057 108.19 94.2057C109.614 94.2057 111.096 93.1988 111.502 91.9612Z"
          fill="white"
        />
        <g>
          <rect
            x="16.9641"
            y="125.607"
            width="115.179"
            height="43.0654"
            rx="12.5607"
            fill="#02A1D1"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M42.9617 137.271H42.5153C41.1984 137.268 39.8972 137.577 38.7198 138.175C35.85 139.616 34.0344 142.566 34.0331 145.794L34.0387 146.125C34.075 147.115 34.2853 148.091 34.6592 149.007L34.7536 149.226L34.1328 150.732C33.8534 151.409 33.8612 152.172 34.1543 152.844L34.2217 152.987C34.8612 154.248 36.3769 154.803 37.6833 154.227L39.1099 153.597L39.3184 153.689C40.3315 154.106 41.4183 154.321 42.5176 154.318C45.7277 154.317 48.6636 152.492 50.0996 149.605C50.6926 148.425 51.0008 147.118 50.9974 145.792L50.9974 145.346C50.7628 141.049 47.445 137.64 43.2493 137.289L42.9617 137.271ZM42.5129 139.065L42.9241 139.065L42.9124 139.064C46.3115 139.253 49.0255 141.98 49.2131 145.395L49.2117 145.794C49.2144 146.84 48.9719 147.868 48.504 148.799C47.3686 151.082 45.0508 152.522 42.5149 152.523C41.4751 152.526 40.4513 152.282 39.5249 151.812C39.287 151.692 39.0078 151.684 38.7637 151.792L36.9659 152.584C36.5143 152.783 35.9877 152.577 35.7896 152.123C35.6919 151.899 35.6893 151.645 35.7824 151.419L36.5543 149.547C36.6539 149.306 36.6438 149.033 36.5265 148.799C36.0586 147.868 35.8161 146.84 35.8188 145.797C35.8198 143.247 37.2531 140.918 39.5215 139.778C40.4513 139.306 41.4751 139.063 42.5129 139.065Z"
          fill="white"
        />
        <path
          d="M63.8407 150.384C63.1959 150.384 62.5847 150.3 62.0069 150.133C61.4374 149.957 60.9727 149.723 60.6126 149.429C60.42 149.287 60.3237 149.086 60.3237 148.827C60.3237 148.651 60.374 148.5 60.4744 148.374C60.5833 148.24 60.7089 148.173 60.8513 148.173C61.002 148.173 61.1737 148.232 61.3663 148.349C61.7263 148.609 62.1032 148.797 62.4967 148.914C62.8903 149.032 63.3257 149.09 63.803 149.09C64.4143 149.09 64.8833 148.986 65.2099 148.776C65.5364 148.559 65.6997 148.245 65.6997 147.834C65.6997 147.516 65.5448 147.273 65.235 147.106C64.9335 146.93 64.4269 146.762 63.7151 146.603C62.9782 146.444 62.3795 146.26 61.9189 146.051C61.4584 145.841 61.1109 145.573 60.8764 145.247C60.6419 144.92 60.5247 144.506 60.5247 144.003C60.5247 143.484 60.6712 143.019 60.9643 142.609C61.2574 142.199 61.6635 141.88 62.1827 141.654C62.7103 141.42 63.3006 141.303 63.9538 141.303C65.1512 141.303 66.1268 141.621 66.8804 142.257C66.9893 142.349 67.0647 142.441 67.1065 142.534C67.1568 142.617 67.1819 142.726 67.1819 142.86C67.1819 143.036 67.1275 143.191 67.0186 143.325C66.9181 143.451 66.7967 143.513 66.6543 143.513C66.5706 143.513 66.491 143.501 66.4157 143.476C66.3487 143.451 66.2566 143.404 66.1393 143.337C65.796 143.086 65.4611 142.902 65.1345 142.785C64.8163 142.659 64.4227 142.596 63.9538 142.596C63.3844 142.596 62.9322 142.714 62.5972 142.948C62.2706 143.174 62.1073 143.492 62.1073 143.903C62.1073 144.246 62.2539 144.51 62.547 144.694C62.8401 144.878 63.3383 145.05 64.0417 145.209C64.787 145.376 65.3899 145.565 65.8504 145.774C66.3194 145.975 66.6753 146.235 66.9181 146.553C67.1693 146.871 67.2949 147.269 67.2949 147.746C67.2949 148.265 67.1484 148.726 66.8553 149.128C66.5706 149.522 66.1645 149.831 65.6369 150.057C65.1177 150.275 64.519 150.384 63.8407 150.384ZM73.7204 144.003C73.9633 144.003 74.1559 144.07 74.2982 144.204C74.4406 144.338 74.5117 144.518 74.5117 144.744V149.618C74.5117 149.836 74.4364 150.011 74.2857 150.145C74.1433 150.279 73.9549 150.346 73.7204 150.346C73.4943 150.346 73.3143 150.284 73.1803 150.158C73.0463 150.032 72.9793 149.861 72.9793 149.643V149.329C72.7867 149.664 72.5271 149.923 72.2006 150.108C71.874 150.284 71.5055 150.371 71.0952 150.371C69.5879 150.371 68.8343 149.526 68.8343 147.834V144.744C68.8343 144.518 68.9055 144.338 69.0478 144.204C69.1902 144.07 69.3786 144.003 69.6131 144.003C69.8559 144.003 70.0485 144.07 70.1908 144.204C70.3332 144.338 70.4044 144.518 70.4044 144.744V147.847C70.4044 148.282 70.4923 148.605 70.6682 148.814C70.844 149.023 71.1203 149.128 71.4972 149.128C71.9326 149.128 72.2801 148.986 72.5397 148.701C72.8077 148.408 72.9417 148.023 72.9417 147.545V144.744C72.9417 144.518 73.0128 144.338 73.1552 144.204C73.2975 144.07 73.4859 144.003 73.7204 144.003ZM79.8998 143.978C80.4273 143.978 80.8963 144.112 81.3066 144.38C81.7253 144.648 82.0477 145.029 82.2738 145.523C82.5082 146.009 82.6255 146.57 82.6255 147.206C82.6255 147.843 82.5082 148.399 82.2738 148.877C82.0477 149.354 81.7295 149.723 81.3191 149.982C80.9088 150.242 80.4357 150.371 79.8998 150.371C79.4643 150.371 79.075 150.279 78.7316 150.095C78.3883 149.911 78.1245 149.656 77.9403 149.329V151.891C77.9403 152.109 77.8691 152.281 77.7268 152.406C77.5844 152.532 77.396 152.595 77.1615 152.595C76.9271 152.595 76.7345 152.528 76.5837 152.394C76.4414 152.26 76.3702 152.084 76.3702 151.866V144.744C76.3702 144.518 76.4372 144.338 76.5712 144.204C76.7135 144.07 76.902 144.003 77.1364 144.003C77.3709 144.003 77.5593 144.07 77.7017 144.204C77.844 144.338 77.9152 144.518 77.9152 144.744V145.058C78.0994 144.715 78.3632 144.451 78.7065 144.267C79.0582 144.074 79.456 143.978 79.8998 143.978ZM79.4853 149.153C79.9793 149.153 80.3645 148.986 80.6409 148.651C80.9172 148.307 81.0554 147.826 81.0554 147.206C81.0554 146.57 80.9172 146.076 80.6409 145.724C80.3645 145.372 79.9793 145.196 79.4853 145.196C78.9829 145.196 78.5935 145.368 78.3171 145.711C78.0492 146.055 77.9152 146.545 77.9152 147.181C77.9152 147.809 78.0492 148.295 78.3171 148.638C78.5935 148.981 78.9829 149.153 79.4853 149.153ZM87.6679 143.978C88.1954 143.978 88.6644 144.112 89.0747 144.38C89.4934 144.648 89.8158 145.029 90.0419 145.523C90.2763 146.009 90.3936 146.57 90.3936 147.206C90.3936 147.843 90.2763 148.399 90.0419 148.877C89.8158 149.354 89.4976 149.723 89.0873 149.982C88.6769 150.242 88.2038 150.371 87.6679 150.371C87.2325 150.371 86.8431 150.279 86.4997 150.095C86.1564 149.911 85.8926 149.656 85.7084 149.329V151.891C85.7084 152.109 85.6372 152.281 85.4949 152.406C85.3525 152.532 85.1641 152.595 84.9297 152.595C84.6952 152.595 84.5026 152.528 84.3519 152.394C84.2095 152.26 84.1383 152.084 84.1383 151.866V144.744C84.1383 144.518 84.2053 144.338 84.3393 144.204C84.4817 144.07 84.6701 144.003 84.9045 144.003C85.139 144.003 85.3274 144.07 85.4698 144.204C85.6121 144.338 85.6833 144.518 85.6833 144.744V145.058C85.8675 144.715 86.1313 144.451 86.4746 144.267C86.8263 144.074 87.2241 143.978 87.6679 143.978ZM87.2534 149.153C87.7474 149.153 88.1326 148.986 88.409 148.651C88.6853 148.307 88.8235 147.826 88.8235 147.206C88.8235 146.57 88.6853 146.076 88.409 145.724C88.1326 145.372 87.7474 145.196 87.2534 145.196C86.751 145.196 86.3616 145.368 86.0852 145.711C85.8173 146.055 85.6833 146.545 85.6833 147.181C85.6833 147.809 85.8173 148.295 86.0852 148.638C86.3616 148.981 86.751 149.153 87.2534 149.153ZM94.7075 150.371C94.0794 150.371 93.5268 150.242 93.0495 149.982C92.5805 149.723 92.2163 149.35 91.9567 148.864C91.6971 148.379 91.5673 147.813 91.5673 147.168C91.5673 146.524 91.6971 145.963 91.9567 145.485C92.2163 145 92.5805 144.627 93.0495 144.367C93.5268 144.108 94.0794 143.978 94.7075 143.978C95.3355 143.978 95.884 144.108 96.3529 144.367C96.8302 144.627 97.1945 145 97.4457 145.485C97.7053 145.963 97.8351 146.524 97.8351 147.168C97.8351 147.813 97.7053 148.379 97.4457 148.864C97.1945 149.35 96.8302 149.723 96.3529 149.982C95.884 150.242 95.3355 150.371 94.7075 150.371ZM94.6949 149.153C95.2057 149.153 95.5951 148.986 95.8631 148.651C96.131 148.316 96.265 147.822 96.265 147.168C96.265 146.524 96.131 146.034 95.8631 145.699C95.5951 145.356 95.2099 145.184 94.7075 145.184C94.205 145.184 93.8157 145.356 93.5393 145.699C93.2714 146.034 93.1374 146.524 93.1374 147.168C93.1374 147.822 93.2714 148.316 93.5393 148.651C93.8073 148.986 94.1925 149.153 94.6949 149.153ZM102.785 144.003C103.002 143.986 103.174 144.032 103.3 144.141C103.425 144.25 103.488 144.414 103.488 144.631C103.488 144.857 103.434 145.025 103.325 145.134C103.216 145.243 103.019 145.314 102.734 145.347L102.358 145.385C101.864 145.435 101.499 145.603 101.265 145.887C101.039 146.172 100.926 146.528 100.926 146.955V149.593C100.926 149.836 100.85 150.024 100.7 150.158C100.549 150.284 100.36 150.346 100.134 150.346C99.9083 150.346 99.7199 150.284 99.5691 150.158C99.4268 150.024 99.3556 149.836 99.3556 149.593V144.732C99.3556 144.497 99.4268 144.317 99.5691 144.192C99.7199 144.066 99.9041 144.003 100.122 144.003C100.34 144.003 100.515 144.066 100.649 144.192C100.783 144.309 100.85 144.48 100.85 144.707V145.209C101.009 144.841 101.244 144.556 101.554 144.355C101.872 144.154 102.224 144.041 102.609 144.016L102.785 144.003ZM108.143 149.178C108.562 149.203 108.771 149.392 108.771 149.743C108.771 149.944 108.687 150.099 108.52 150.208C108.361 150.309 108.13 150.351 107.829 150.334L107.49 150.309C106.083 150.208 105.38 149.455 105.38 148.048V145.31H104.752C104.526 145.31 104.35 145.259 104.224 145.159C104.107 145.058 104.048 144.912 104.048 144.719C104.048 144.527 104.107 144.38 104.224 144.28C104.35 144.179 104.526 144.129 104.752 144.129H105.38V142.973C105.38 142.747 105.451 142.567 105.593 142.433C105.736 142.299 105.928 142.232 106.171 142.232C106.405 142.232 106.594 142.299 106.736 142.433C106.879 142.567 106.95 142.747 106.95 142.973V144.129H108.017C108.243 144.129 108.415 144.179 108.532 144.28C108.658 144.38 108.721 144.527 108.721 144.719C108.721 144.912 108.658 145.058 108.532 145.159C108.415 145.259 108.243 145.31 108.017 145.31H106.95V148.161C106.95 148.78 107.234 149.111 107.804 149.153L108.143 149.178Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_d"
            x="6.19776"
            y="120.224"
            width="136.711"
            height="64.5981"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="5.38318" />
            <feGaussianBlur stdDeviation="5.38318" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.247059 0 0 0 0 0.54902 0 0 0 0 1 0 0 0 0.263686 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </a>
    <div class="p-d-flex p-jc-center p-p-4">
      {{ $t("message.version", { version: version }) }}
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import AppSubmenu from "./AppSubmenu";
export default {
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
    };
  },
  name: "AppMenu",
  emits: ["menu-click", "menuitem-click", "root-menuitem-click"],
  props: {
    model: Array,
    layoutMode: String,
    active: Boolean,
    mobileMenuActive: Boolean,
  },
  methods: {
    onMenuClick(event) {
      this.$emit("menu-click", event);
    },
    onMenuItemClick(event) {
      this.$emit("menuitem-click", event);
    },
    onRootMenuItemClick(event) {
      this.$emit("root-menuitem-click", event);
    },
  },
  components: { AppSubmenu },
};
</script>
